import React, { useContext } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import OpenPopupBtn from "../../../common/OpenPopupBtn";
import { Cases, btnName, modalsName } from "../../../constant";
import ByteCardBuilderContext from "../../../context/BytecardBilderContext/ByteCardBuilderContext";
import { OpenModalCommonFunc } from "../../../utils";
import CardBuilderHeaderSection from "../../../common/cardBuilderHeaderSection";
import CommonPopup from "../../../Modals/commonPopup";
import ProductFeaturesPopup from "./ProductFeaturesPopup";

const ProductFeatures = () => {
  const { setAllPopupState, allPopupState } = useContext(
    ByteCardBuilderContext
  );
  return (
    <>
      <Col xl="12 box-col-6" md="12">
        <Card className="ecommerce-widget mt-4 cardHover">
          <CardBody className="support-ticket-font box-border-div">
            <Row>
              <div className="col-12">
                <CardBuilderHeaderSection name="Product Features" />
              </div>
              <OpenPopupBtn
                openPopup={() =>
                  OpenModalCommonFunc(Cases.PRODUCT_FEATURES, setAllPopupState)
                }
                name={btnName.PRODUCT_FEATURES}
              />
            </Row>
          </CardBody>
        </Card>
      </Col>

      <CommonPopup
        open={allPopupState.productFeaturesPopup}
        close={() =>
          OpenModalCommonFunc(Cases.PRODUCT_FEATURES, setAllPopupState, false)
        }
        modalName={modalsName.PRODUCT_FEATURES}
        modalCase={Cases.PRODUCT_FEATURES}
        edit={false}
        content={<ProductFeaturesPopup />}
      />
    </>
  );
};

export default ProductFeatures;
